import { Flex, Text, Toggle } from "src/elements";

interface Props {
  title: string;
  description?: string;
  value: boolean;
  setValue: (value: boolean) => void;
  isDisabled?: boolean;
}

export const RuleToggle = ({ title, description, value, setValue, isDisabled }: Props) => {
  return (
    <Flex column justify="center" padding="10px" gap="10px">
      <Text variant="small1" textAlign="center" isDisabled={isDisabled}>
        {title}
      </Text>

      {description && (
        <Text variant="small2" textAlign="center" isDisabled={isDisabled}>
          {description}
        </Text>
      )}

      <Toggle
        value={value}
        setValue={setValue}
        isDisabled={isDisabled}
        offLabel="No"
        onLabel="Yes"
      />
    </Flex>
  );
};
